import React from 'react';
import './style.css';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';

const HeaderQuestion = props => {
  const { t } = props;

  let skip = () => {
    const nextPath = props.skip(props);
    if (props.history.canGo(1)) {
      props.history.goForward();
    } else {
      props.history.push(nextPath);
    }
  };

  let buttonClass = 'btn-secondary';
  if (props.colorButton) {
    buttonClass = 'btn-danger';
  }
  buttonClass = 'btn btn-round ' + buttonClass;

  return (
    <div className="App-question">
      <div className="row">
        <div className="col-sm-9 text-left">
          <div className="App-question-text">{props.description}</div>
          <div className="App-question-instructions">{props.text}</div>
        </div>
        <div className="col-sm-3 text-right">
          {props.skip ? (
            <button type="button" className={buttonClass} onClick={skip}>
              {t('Skip')}
            </button>
          ) : (
            <div />
          )}
        </div>
      </div>
    </div>
  );
};

export default withRouter(translate('translations')(HeaderQuestion));



// WEBPACK FOOTER //
// ./src/comparison/components/HeaderQuestion/index.js